import router from "./router";
// import NProgress from "nprogress"; // progress bar
// import "nprogress/nprogress.css"; // progress bar style

// NProgress.configure({ showSpinner: false }); // NProgress Configuration

router.beforeEach(async (to, from, next) => {
  // console.log(to.path, from, next, "路由拦截");
  // start progress bar
  //   NProgress.start();
  if (to.path === "/") {
    // if is logged in, redirect to the home page\
    // NProgress.done();
    next({ path: "/home" });
  } else {
    next();
  }
});

function getQuery(query) {
  let str = "";
  for (const key in query) {
    str = `${key}=${query[key]}&`;
  }
  return str;
}
router.afterEach(() => {
  // finish progress bar
  //   NProgress.done();
});



// WEBPACK FOOTER //
// ./src/permission.js